import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

import { useManualQuery } from 'graphql-hooks'

import { Breadcrumb } from 'antd'

import * as logger from '../../../../services/logger'

import IntlMessages from '../../../../util/IntlMessages'

import { IGetLocationById } from '../../../../types/locations'
import { getLocationById } from '../../../../graphql/custom-queries'
import { FrontendUrls } from '../../../../types/urls'
import LocationHolidayForm from '../../../../components/location-holiday-form'
import CircularProgress from '../../../../components/circular-progress'
import { userHasDefaultWorkingHours } from '@vacationtracker/shared/functions/work-week'

interface IAddHolidaysPage {
  match: {
    params: {
      locationId: string
      holidayId?: string
    }
  }
}

const AddHolidayPage = ({ match }: IAddHolidaysPage): React.ReactElement => {
  const [location, setLocation] = useState<IGetLocationById>()
  const [isLoading, setIsLoading] = useState(true)

  const [ getLocation ] = useManualQuery<{getLocation: IGetLocationById}, { id: string }>(getLocationById)

  useEffect(() => {
    fetchLocation(match.params.locationId)
  }, [match.params.locationId])

  const fetchLocation = async (id: string) => {
    try {
      const response = await getLocation({ variables: { id }})
      if (!response.data || response.error) throw response.error
      setLocation(response.data.getLocation)
      setIsLoading(false)
    } catch (err) { logger.error('error fetching location', err) }
  }

  return <div className='main-content form-background'>
    {isLoading ? <CircularProgress /> :
      <>
        <div className="main-content-header">
          <div className="main-content-header-title">
            <IntlMessages id="components.createHolidaysForm.title" />
          </div>
          <div className="main-content-header-breadcrumb">
            <Breadcrumb
              items={[
                { title: <Link to={FrontendUrls.dashboard}><IntlMessages id="sidebar.dashboard" /></Link> },
                { title: <IntlMessages id='sidebar.section.leaveSetupLowercase' /> },
                { title: <Link to='/app/settings/locations'><IntlMessages id="app.locations" /></Link> },
                { title: <Link to={`/app/settings/locations/${location?.id}/holidays`}>{location?.name}</Link> },
                { title: <IntlMessages id={match.params.holidayId ? 'components.createHolidaysForm.createIntro1TitleEdit' : 'components.createHolidaysForm.createIntro1Title'} /> },
              ]} />
          </div>
        </div><div className="main-content-body">
          <LocationHolidayForm
            locationId={location?.id as string}
            locationName={location?.name as string}
            workWeek={location?.workWeek as number[]}
            defaultWorkingHours={userHasDefaultWorkingHours(location?.workHours)}
            existingLocationHolidays={location?.holidays || []}
            existingHolidayId={match.params.holidayId}
          />
        </div>
      </>}
  </div>
}

export default AddHolidayPage
